import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ImplementationGuideService {
    static getSteps() {
        return HttpUtil.get(API_ROUTES.IMPLEMENTATION_GUIDE.GET_STEPS);
    }
}